import Vue from 'vue';
import Axios from 'axios';
import stringify from 'qs-stringify';
import router from '@/router';
import { TokenService, ProfileService } from './local-storage';
import toast from '../libs/toastify';

function destroyLocalToken() {
  TokenService.remove();
  ProfileService.remove();
  router.push('/login');
}

// create axios instance
const instanceAxios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// update token every request
instanceAxios.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${TokenService.get()}`;
    return config;
  },
  (error) => Promise.reject(error),
);

instanceAxios.interceptors.response.use((response) => response, (error) => {
  // if (error.response?.status === 401) {
  //   // toast.warning('Your credential is invalid, Please login again');
  //   destroyLocalToken();
  // } else if (error.response?.status === 403) {
  //   toast.warning(`Forbidden! ${error.response.data.message}`);
  // } else if (error.response?.status === 429) {
  //   toast.warning('Error Too many request');
  // } else if (error.response?.status >= 500) {
  //   toast.warning(`${error.response.status} API Server Error`);
  // } else if (error.response?.status === 400) {
  //   console.log('Error 400 Bad request');
  // }
  throw error;
});

const endpoints = {
  getOrganizations(params) {
    return instanceAxios.get('/energyMonitor/organizations', {
      params,
    });
  },
  getOrganizationDetail(organizationId) {
    return instanceAxios.get(`/energyMonitor/organizations/${organizationId}`);
  },
  getHealthPadData(organizationId) {
    return instanceAxios.get(`/energyMonitor/organizations/${organizationId}/healthPad`);
  },
  getUnitDetail(id, params) {
    return instanceAxios.get(`/energyMonitor/fields/${id}`, { params });
  },
  getUnitEnergy(id, params) {
    return instanceAxios.get(`/energyMonitor/fields/${id}/energies`, { params });
  },
  getBuildingDetail(id, params) {
    return instanceAxios.get(`/energyMonitor/blocks/${id}`, { params });
  },
  getDeviceDetail(id, params) {
    return instanceAxios.get(`/api/devices/${id}`, { params });
  },
  getDeviceUplinks(params) {
    return instanceAxios.get('/api/uplinks', {
      params,
    });
  },
  login(data) {
    return instanceAxios.post('/oauth/token', data);
  },
  getProfile() {
    return instanceAxios.get('/api/profile');
  },
  // getFields(params, cancelToken = null) {
  //   return instanceAxios.get('/energyMonitor/fields', {
  //     params,
  //     cancelToken,
  //   });
  // },
  // getFieldDetail(id, params) {
  //   return instanceAxios.get(`/energyMonitor/fields/${id}`, { params });
  // },
  // getFieldDevices(id, params) {
  //   return instanceAxios.get(`/energyMonitor/fields/${id}/devices`, { params });
  // },
  // getFieldCumulativePayload(id, params, cancelToken = null) {
  //   return instanceAxios.get(`/energyMonitor/fields/${id}/energies`, {
  //     params,
  //     cancelToken,
  //   });
  // },
  // getGroupingTotalEnergies(id, params, cancelToken = null) {
  //   return instanceAxios.get(`/energyMonitor/fields/${id}/energies/total`, {
  //     params,
  //     cancelToken,
  //   });
  // },
  // getBlocks(id, params) {
  //   return instanceAxios.get(`/energyMonitor/fields/${id}/blocks`, {
  //     params,
  //   });
  // },
  // updateBlock(blockId, data) {
  //   return instanceAxios.put(`/energyMonitor/blocks/${blockId}`, data);
  // },
  // getBlockDetail(id, params) {
  //   return instanceAxios.get(`/energyMonitor/blocks/${id}`, { params });
  // },
  // getBlockPeriods(id, params) {
  //   return instanceAxios.get(`/energyMonitor/blocks/${id}/periods`, { params });
  // },
  // createBlockPeriod(id, data) {
  //   return instanceAxios.post(`/energyMonitor/blocks/${id}/periods`, data);
  // },
  // updateBlockPeriod(blockId, periodId, data) {
  //   return instanceAxios.put(`/energyMonitor/blocks/${blockId}/periods/${periodId}`, data);
  // },
  // finishBlockPeriod(blockId, periodId, data) {
  //   return instanceAxios.put(`/energyMonitor/blocks/${blockId}/periods/${periodId}/finish`, data);
  // },
  // deleteBlockPeriod(blockId, periodId) {
  //   return instanceAxios.delete(`/energyMonitor/blocks/${blockId}/periods/${periodId}`);
  // },

  // getSectionEnergies(id, groupingId, params, cancelToken = null) {
  //   return this.getGroupingEnergies(groupingId, {
  //     block_id: id,
  //     ...params,
  //   }, cancelToken);
  // },
  // getSectionTotalEnergies(id, groupingId, params, cancelToken = null) {
  //   return this.getGroupingTotalEnergies(groupingId, {
  //     block_id: id,
  //     ...params,
  //   }, cancelToken);
  // },
  // getUplinkPayloads(params, cancelToken = null) {
  //   return instanceAxios.get('/energyMonitor/uplinks', {
  //     params,
  //     cancelToken,
  //   });
  // },
  // getDevices(params) {
  //   return instanceAxios.get('/energyMonitor/devices', {
  //     params,
  //     paramsSerializer: (prm) => stringify(prm),
  //   });
  // },
  // getDeviceDetail(deviceId) {
  //   return instanceAxios.get(`/energyMonitor/devices/${deviceId}`);
  // },
  // scheduleCommands(downlink) {
  //   return instanceAxios.post('/energyMonitor/commands/schedules', downlink);
  // },
  // getDeviceEnergies(id, params, cancelToken = null) {
  //   return instanceAxios.get(`/energyMonitor/devices/${id}/energies`, {
  //     params,
  //     cancelToken,
  //   });
  // },
  // getDeviceTotalEnergies(id, params, cancelToken = null) {
  //   return instanceAxios.get(`/energyMonitor/devices/${id}/energies/total`, {
  //     params,
  //     cancelToken,
  //   });
  // },

  // getCancelToken() {
  //   return Axios.CancelToken.source();
  // },
  // isCancel(err) {
  //   return Axios.isCancel(err);
  // },
};

// global this.$api
Vue.prototype.$api = endpoints;

// also support for single import
export default endpoints;
